// extracted by mini-css-extract-plugin
export default {"link":"styles_link__-NXyX"};